import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import propTypes from "../../../../constants/propTypes";
import {
  showSnackNotificationAction,
  closeModalDialog,
} from "../../../../actions/layoutActions";
import {
  performUpdateRequest,
  setReload,
} from "../../../../actions/dataComponentActions";
import { processUpdateRequestStatus } from "../../../../utils/dataComponentUtils";
import { getDataComponent } from "../../../../reducers/dataComponentReducer";
import withPORevision from "../../../../withPORevision";
import { ActionButtons } from "../../../forms";
import styled from "styled-components";
import Paper from "../../../mui/core/Paper";

const Title = styled.div`
  padding: 24px 24px 24px 24px;
`;

const StyledPaper = styled(Paper)`
  margin-bottom: 0px;

  ${Paper} {
    box-shadow: none;
    overflow-y: auto;
    max-height: 300px;
  }
`;
export class IncompleteSpecContainer extends Component {
  componentDidUpdate({ dataComponent: prevDataComponent }) {
    const {
      dataComponent,
      closeModalDialog,
      dataComponentId,
      setReload,
    } = this.props;

    processUpdateRequestStatus(prevDataComponent, dataComponent, {
      onSuccess: () => {
        closeModalDialog();
        setReload(dataComponentId, true);
      },
      onError: this.handleUpdateRequestError,
    });
  }

  handleUpdateRequestError = ({ data }) => {
    const { showSnackNotificationAction } = this.props;

    data.errors.map(error => {
      if (error.global) {
        showSnackNotificationAction(error.title);
      }
    });
  };

  handleFlagAsIncomplete = () => {
    const { specId, performUpdateRequest, dataComponentId } = this.props;
    const params = {
      isIncomplete: true,
    };

    performUpdateRequest(dataComponentId, specId, params);
  };

  render() {
    const { spec, dataComponentId } = this.props;
    return (
      <StyledPaper>
        <Title>
          Are you sure you want to flag as incomplete {spec.customNumber}{" "}
          {spec.description}?
        </Title>
        <ActionButtons
          onSend={this.handleFlagAsIncomplete}
          sendButtonText="Flag as Incomplete"
          isModal
          listeners={[dataComponentId]}
        />
      </StyledPaper>
    );
  }
}

IncompleteSpecContainer.propTypes = {
  spec: propTypes.spec,
  specId: PropTypes.string.isRequired,
  dataComponentId: PropTypes.string.isRequired,
  dataComponent: propTypes.dataComponent.isRequired,
  performUpdateRequest: PropTypes.func.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  showSnackNotificationAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state, { dataComponentId }) => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return {
    dataComponent,
  };
};

const mapDispatchToProps = {
  performUpdateRequest,
  closeModalDialog,
  showSnackNotificationAction,
  setReload,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withPORevision(IncompleteSpecContainer));
